import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const alterarOcorrencia = ({ id, descricao, observacao, idc_status }) => {
  return axios.patch(
    process.env.URL_API_BASE + '/ocorrencia/' + id,
    {
      descricao: descricao,
      observacao: observacao,
      idc_status: idc_status,
      updated_by: ActionsLogin.getUsuario().cd_usuario
    },
    config
  )
}

const listarOcorrencias = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/ocorrencia',
    config
  )
  return response.data
}

export const obterOcorrencia = async id => {
  let response = await axios.get(
    process.env.URL_API_BASE + '/ocorrencia/' + id,
    config
  )
  return response.data
}

export default {
  alterarOcorrencia,
  listarOcorrencias,
  obterOcorrencia
}



// WEBPACK FOOTER //
// ./src/actions/OcorrenciaActions.js